export default "__VITE_ASSET__kKHlhPBF__"